export class ReferenceDataItem {
    Id: string;
    Name: string;
}

export default ReferenceDataItem;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/referenceDataItem.ts